<template>
  <div class="header_container">
    <span style="float: left;">
      <img src="../assets/imgs/LOGOss.jpg" width="100px" height="35px" usemap="#planetmap"/>
      <!-- <map name="planetmap">
        <area shape="rect" coords="14,2,35,15" @click="putColor(pink)" :title="$t('lang.lab_pinkType')" style="cursor: pointer;"/>
        <area shape="rect" coords="3,12,16,29" @click="putColor(green)" :title="$t('lang.lab_greenType')" style="cursor: pointer;"/>
        <area shape="rect" coords="20,22,37,34" @click="putColor(blue_green)" :title="$t('lang.lab_blueType')" style="cursor: pointer;"/>
      </map> -->
    </span>
    <span style="float: right;" class="rightPostiton click4">   
      <!-- <i class="el-icon-full-screen fullScreen" title="全屏" @click="fullScreen()" v-if="allScreen === 1"></i>
      <i class="el-icon-full-screen fullScreen" title="退出全屏" @click="exitFullScreen()" v-if="allScreen === 0"></i> -->
      <!-- <a class="rightPostiton click2">
        <i class="el-icon-message-solid" @click="showMessage()"></i>
      </a> -->
    <el-dropdown @command="handleCommand" menu-align='start' class="userMessage">
      <span class="userName-style"><i class="el-icon-user-solid margin-r10"></i>{{user}}</span>
      <el-dropdown-menu slot="dropdown">
        <!-- <el-dropdown-item >{{$t('lang.lab_primaryColor')}}:
          <el-color-picker v-model="color" size="small" :predefine="predefineColors" @change="putColor(color)"></el-color-picker>
        </el-dropdown-item> -->
        <!-- 隐藏中英文功能 -->
        <!-- <el-dropdown-item command="changeLangEvent">{{$t('lang.lab_zhCn')}}</el-dropdown-item> -->
        <el-dropdown-item command="password">{{$t('lang.lab_modifyPwd')}}</el-dropdown-item>
        <el-dropdown-item command="signout"><i class="el-icon-switch-button"></i>{{$t('lang.lab_exit')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    </span>
    
  </div>
</template>

<script>
const version = require('element-ui/package.json').version // element-ui version 
const ORIGINAL_THEME = '#409EFF' // default color
const PREDE_THEME = [
          '#00b1c3',
          '#ed8599',
          '#b4d049',
          '#ff4500',
          '#ff8c00',
          '#ffd700',
          '#90ee90',
          '#00ced1',
          ] // 预定义主题颜色
  export default {

    data() {
      return {
        lang: 'zh-CN',
        chalk: '', // content of theme-chalk css
        theme: '',
        color: ORIGINAL_THEME,
        predefineColors: PREDE_THEME,
        drawer: false, // 系统设定抽屉
        user: '',
        colorChange: {},
        userId: '',
        style: '',
        styleList: [],
        blue_green: {
          top: '#00b1c3',
          button: '#006d9a'
        },
        pink: {
          top: '#ed8599',
          button: '#c84b71'
        },
        green: {
          top: '#b4d049',
          button: '#4ea00b'
        },
        show: false,
        allScreen: 1
      }
    },
    created() {
      this.user = localStorage.getItem('accountNumber')
      this.userId = JSON.parse(window.localStorage.getItem('userData')).id
      this.style = JSON.parse(window.localStorage.getItem('userData')).style
      this.styleList = this.style.split(',')
      this.colorChange = {
        top: this.styleList[0],
        button: this.styleList[1]
      }
      this.$store.commit('setColorChange', this.colorChange)
      this.$store.commit('CHANGE_SETTING', this.styleList[0])
    },
    mounted() {
    },
    computed: {
      // 定义默认的主题颜色
      defaultTheme() {
        return this.$store.state.theme
      }
    },
    watch: {
      // 监听默认主题颜色的变化，如果发生变化就更改theme的值
      defaultTheme: {
        handler: function(val, oldVal) {
          this.theme = val
        },
        immediate: true
      },
      // 监听theme
      async theme(val) {
        const oldVal = this.chalk ? this.theme : ORIGINAL_THEME
        if (typeof val !== 'string') return
        // 把颜色拆分成#和字母形式，然后根据后面的字母转换成rgba格式
        const themeCluster = this.getThemeCluster(val.replace('#', ''))
        const originalCluster = this.getThemeCluster(oldVal.replace('#', ''))
        const $message = this.$message({
          message: this.$i18n.t('lang.lab_changeColor'),
          customClass: 'theme-message',
          type: 'success',
          duration: 0,
          iconClass: 'el-icon-loading'
        })
        const getHandler = (variable, id) => {
          return () => {
            // 点击换肤，生成一套新的颜色
            const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''))
            const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster)
            // 获取到style
            let styleTag = document.getElementById(id)
            if (!styleTag) {
              styleTag = document.createElement('style')
              styleTag.setAttribute('id', id)
              document.head.appendChild(styleTag)
            }
            styleTag.innerText = newStyle
          }
        }
        if (!this.chalk) {
          // 判断packpage中是否已经安装了element-ui
          const url = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`
          await this.getCSSString(url, 'chalk')
        }
        const chalkHandler = getHandler('chalk', 'chalk-style')
        chalkHandler()
        // 获取到改变后的style
        const styles = [].slice.call(document.querySelectorAll('style'))
          .filter(style => {
            const text = style.innerText
            return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text)
          })
        // 重新给style赋值成新的css
        styles.forEach(style => {
          const { innerText } = style
          if (typeof innerText !== 'string') return
          style.innerText = this.updateStyle(innerText, originalCluster, themeCluster)
        })
        this.$emit('change', val)
        $message.close()
      }
    },
    methods: {
      // 异步函数，原理为promise
      async handleCommand(command) {
				if (command == 'home') {
					this.$router.push('/manage')
				} else if (command == 'signout') {
          localStorage.clear() // 清理localStorage里面的所有数据
					this.$router.push({ name: 'login' })
        } else if (command == 'changeLangEvent') {
          if (this.lang === 'zh-CN') {
            this.lang = 'en-US'
            this.$i18n.locale = this.lang// 关键语句
          } else {
            this.lang = 'zh-CN'
            this.$i18n.locale = this.lang// 关键语句
          }
        } else if (command == 'password') {
          this.$router.push('/manage/password')
        }
      },
      updateStyle(style, oldCluster, newCluster) {
        // 换肤显示的所有颜色，例如悬停、边框、字体颜色、选中态等等
        let newStyle = style
        oldCluster.forEach((color, index) => {
          newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
        })
        // 返回element的字体，想要换肤，就必须执行此步骤
        return newStyle
      },
      // 如果没有安装element-ui，利用promise方法进行安装
      getCSSString(url, variable) {
        return new Promise(resolve => {
          const xhr = new XMLHttpRequest()
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
              this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '')
              resolve()
            }
          }
          xhr.open('GET', url)
          xhr.send()
        })
      },
      // 根据theme的值，转换成rgba的格式，然后返回
      getThemeCluster(theme) {
        const tintColor = (color, tint) => {
          let red = parseInt(color.slice(0, 2), 16)
          let green = parseInt(color.slice(2, 4), 16)
          let blue = parseInt(color.slice(4, 6), 16)

          if (tint === 0) { // when primary color is in its rgb space
            return [red, green, blue].join(',')
          } else {
            red += Math.round(tint * (255 - red))
            green += Math.round(tint * (255 - green))
            blue += Math.round(tint * (255 - blue))

            red = red.toString(16)
            green = green.toString(16)
            blue = blue.toString(16)

            return `#${red}${green}${blue}`
          }
        }

        const shadeColor = (color, shade) => {
          let red = parseInt(color.slice(0, 2), 16)
          let green = parseInt(color.slice(2, 4), 16)
          let blue = parseInt(color.slice(4, 6), 16)

          red = Math.round((1 - shade) * red)
          green = Math.round((1 - shade) * green)
          blue = Math.round((1 - shade) * blue)

          red = red.toString(16)
          green = green.toString(16)
          blue = blue.toString(16)

          return `#${red}${green}${blue}`
        }

        const clusters = [theme]
        for (let i = 0; i <= 9; i++) {
          clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
        }
        clusters.push(shadeColor(theme, 0.1))
        return clusters
      },
      // 全屏
      fullScreen() {
        this.allScreen = 0
        var el = document.documentElement
        var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
        if (typeof rfs != 'undefined' && rfs) {
          rfs.call(el)
        }
      },
      // 退出全屏
      exitFullScreen() {
        this.allScreen = 1
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      },
      // 我的消息
      showMessage() {
        this.$router.push('/manage/message')     
      },
      // 利用Vuex传递颜色
      putColor(color) {
        let colorTemp = {
          top: color,
          button: color
        }
        this.colorChange = colorTemp
        // let params = {
        //   style: color.top + ',' + color.button,
        //   staffId: JSON.parse(localStorage.getItem('userData')).id
        // }
        this.$store.commit('setColorChange', this.colorChange)
        this.$store.commit('CHANGE_SETTING', color.top)
      },
    }
  }
</script>

<style lang="scss">
  @import '../style/mixin.scss';
  .header_container {
    .el-dropdown {
      color: black;
    }
    width: 100%;
    // background-color: #EFF2F7;
    height: 40px;
    display: flex;
    float: left;
    align-items: center;
    padding-left: 20px;
    background-color: white;
    margin-bottom: 10px;
    .userMessage {
      cursor: pointer;
      .userName-style{
        font-size: 20px;
        .margin-r10{
          margin-right:5px;
        }
      }
    }
    .fullScreen {
      cursor: pointer;
      color: black;
      margin-right: 10px;
    }
    .el-dropdown-menu__item {
      text-align: center;
    }
    .el-dropdown-menu {
      z-index: 9999 !important;
    }
    .rightPostiton {
      color: black;
    }
    .blue_green {
      height: 20px;
      width: 20px;
      background-color: #00b1c3;
      margin: 10px;
      cursor: pointer;
      border-radius: 6px;
    }
    .pink {
      height: 20px;
      width: 20px;
      background-color: #c84b71;
      margin: 10px;
      cursor: pointer;
      border-radius: 6px;
    }
    .green {
      height: 20px;
      width: 20px;
      background-color: #4ea00b;
      margin: 10px;
      cursor: pointer;
      border-radius: 6px;
    }
    .click2 {
      margin: 20px;
    }
    .click4 {
      position: absolute;
      right: 30px;
    }
  }
</style>